const DesignPlanIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <rect width="24" height="24" fill="#3BAFAB" rx="12"></rect>
    <path
      fill="#fff"
      d="M19.726 5.27a.976.976 0 0 0-1.277-.536h-.012a22 22 0 0 0-6.334 4.24 15 15 0 0 0-3.491 5.062 1.94 1.94 0 0 0-1.502.328c-.943.622-.765 1.83-.891 2.531-.127.702-1.266 1.266-1.266 1.266-.242.138-.213.345.564.765a3.16 3.16 0 0 0 3.79-.742c.622-.581.956-1.41.91-2.26.028-.006.051 0 .08-.012a15.1 15.1 0 0 0 5.183-3.55 22 22 0 0 0 4.246-6.345 1 1 0 0 0 0-.736zm-9.9 9.347a.7.7 0 0 1-.121-.143c.264-.604.57-1.185.909-1.75.454.283.834.668 1.116 1.123q-.838.518-1.743.914a.6.6 0 0 1-.167-.144zm2.899-1.42a4.6 4.6 0 0 0-1.456-1.456 14 14 0 0 1 1.663-1.916 20.7 20.7 0 0 1 5.482-3.779 20.6 20.6 0 0 1-3.78 5.494 14 14 0 0 1-1.915 1.662z"
    ></path>
  </svg>
);

export default DesignPlanIcon;
